const $058c5ce0a1ed7cc4$export$fff9d43727b7dcf7 = {
    en: {
        services: {
            video: "Video Production",
            photography: "Photography",
            social: "Social Media Content",
            print: "Print Materials",
            website: "Website Solutions"
        },
        industries: {
            restaurants: {
                title: "Restaurants & Cafes",
                video: [
                    "Food plating videos",
                    "Customer testimonials",
                    "Ambiance videos",
                    "Chef interviews",
                    "Behind-the-scenes kitchen tours",
                    "Menu item spotlights",
                    "How-to cooking videos"
                ],
                photography: [
                    "High-quality food photography",
                    "Interior/exterior shots",
                    "Staff photos",
                    "Event photography"
                ],
                social: [
                    "Engaging posts with food visuals",
                    "Daily specials",
                    "Customer contests",
                    "Influencer collaborations"
                ],
                print: [
                    "Menus",
                    "Flyers",
                    "Table tents",
                    "Loyalty cards",
                    "Business cards"
                ],
                website: [
                    "Online ordering system",
                    "Reservations",
                    "Food delivery partnerships"
                ]
            },
            retail: {
                title: "Retail Stores",
                video: [
                    "Product demos",
                    "Customer testimonials",
                    "Unboxing videos",
                    "Store tours",
                    "Seasonal promotions",
                    "Influencer collaborations"
                ],
                photography: [
                    "High-quality product photography",
                    "Lifestyle shots",
                    "Store interior/exterior shots",
                    "Model shots"
                ],
                social: [
                    "Product launches",
                    "Sales announcements",
                    "Behind-the-scenes",
                    "Customer spotlights",
                    "Influencer marketing"
                ],
                print: [
                    "Brochures",
                    "Flyers",
                    "Window displays",
                    "In-store signage",
                    "Price tags",
                    "Business cards"
                ],
                website: [
                    "E-commerce platform",
                    "Online catalogs",
                    "Customer reviews"
                ]
            },
            salons: {
                title: "Salons & Spas",
                video: [
                    "Treatment demonstrations",
                    "Client testimonials",
                    "Spa tours",
                    "Before-and-after transformations",
                    "Staff introductions"
                ],
                photography: [
                    "High-quality service images",
                    "Staff photos",
                    "Spa ambiance",
                    "Client portraits"
                ],
                social: [
                    "Treatment specials",
                    "Promotions",
                    "Staff spotlights",
                    "Client transformations"
                ],
                print: [
                    "Service menus",
                    "Gift certificates",
                    "Business cards",
                    "Promotional materials"
                ],
                website: [
                    "Online booking",
                    "Service descriptions",
                    "Staff profiles"
                ]
            },
            fitness: {
                title: "Fitness Centers & Gyms",
                video: [
                    "Workout tutorials",
                    "Member success stories",
                    "Facility tours",
                    "Class previews",
                    "Trainer introductions"
                ],
                photography: [
                    "Facility photos",
                    "Class action shots",
                    "Equipment demonstrations",
                    "Member transformations"
                ],
                social: [
                    "Workout tips",
                    "Nutrition advice",
                    "Member spotlights",
                    "Class schedules",
                    "Special events"
                ],
                print: [
                    "Class schedules",
                    "Membership brochures",
                    "Business cards",
                    "Promotional flyers"
                ],
                website: [
                    "Class booking system",
                    "Membership options",
                    "Trainer profiles"
                ]
            },
            realestate: {
                title: "Real Estate Agencies",
                video: [
                    "Property tours",
                    "Area guides",
                    "Agent introductions",
                    "Client testimonials",
                    "Market updates"
                ],
                photography: [
                    "Professional property photos",
                    "Aerial photography",
                    "Agent headshots",
                    "Community features"
                ],
                social: [
                    "Property listings",
                    "Open house announcements",
                    "Market insights",
                    "Client success stories"
                ],
                print: [
                    "Property brochures",
                    "Business cards",
                    "Direct mail materials",
                    "Property flyers"
                ],
                website: [
                    "Property listings",
                    "Virtual tours",
                    "Agent profiles",
                    "Client testimonials"
                ]
            },
            professional: {
                title: "Professional Services",
                video: [
                    "Client testimonials",
                    "Service explanations",
                    "Company culture videos",
                    "Expert interviews",
                    "Process demonstrations"
                ],
                photography: [
                    "Professional headshots",
                    "Office environment",
                    "Team photos",
                    "Event coverage"
                ],
                social: [
                    "Industry insights",
                    "Company updates",
                    "Team spotlights",
                    "Client success stories"
                ],
                print: [
                    "Service brochures",
                    "Business cards",
                    "Presentation folders",
                    "Case study documents"
                ],
                website: [
                    "Service descriptions",
                    "Team profiles",
                    "Client portal",
                    "Case studies"
                ]
            },
            homeservices: {
                title: "Home Services",
                video: [
                    "Service demonstrations",
                    "Client testimonials",
                    "Before-and-after transformations",
                    "Team introductions",
                    "Safety procedures"
                ],
                photography: [
                    "Before/after photos",
                    "Team photos",
                    "Equipment/tools",
                    "Service process shots"
                ],
                social: [
                    "Maintenance tips",
                    "Seasonal services",
                    "Customer reviews",
                    "Special offers"
                ],
                print: [
                    "Service brochures",
                    "Business cards",
                    "Estimate forms",
                    "Door hangers"
                ],
                website: [
                    "Service descriptions",
                    "Online booking",
                    "Service areas",
                    "Emergency services"
                ]
            },
            ecommerce: {
                title: "E-commerce Businesses",
                video: [
                    "Product demonstrations",
                    "Unboxing experiences",
                    "Customer testimonials",
                    "Behind-the-scenes",
                    "Product launches"
                ],
                photography: [
                    "Product photography",
                    "Lifestyle shots",
                    "Package/unboxing",
                    "360-degree views"
                ],
                social: [
                    "Product features",
                    "Customer reviews",
                    "Special promotions",
                    "How-to guides"
                ],
                print: [
                    "Product catalogs",
                    "Packaging design",
                    "Insert cards",
                    "Promotional materials"
                ],
                website: [
                    "E-commerce platform",
                    "Product pages",
                    "Shopping cart",
                    "Customer reviews"
                ]
            }
        }
    },
    de: {
        services: {
            video: "Videoproduktion",
            photography: "Fotografie",
            social: "Social Media Inhalte",
            print: "Druckmaterialien",
            website: "Website-L\xf6sungen"
        },
        industries: {
            restaurants: {
                title: "Restaurants & Caf\xe9s",
                video: [
                    "Videos zur Essenpr\xe4sentation",
                    "Kundenbewertungen",
                    "Ambiente-Videos",
                    "Koch-Interviews",
                    "Blick hinter die Kulissen der K\xfcche",
                    "Men\xfcpunkt-Highlights",
                    "Koch-Tutorial-Videos"
                ],
                photography: [
                    "Hochwertige Foodfotografie",
                    "Innen-/Au\xdfenaufnahmen",
                    "Mitarbeiterfotos",
                    "Event-Fotografie"
                ],
                social: [
                    "Ansprechende Posts mit Essensbildern",
                    "Tagesangebote",
                    "Kundengewinnspiele",
                    "Influencer-Kooperationen"
                ],
                print: [
                    "Speisekarten",
                    "Flyer",
                    "Tischaufsteller",
                    "Treuekarten",
                    "Visitenkarten"
                ],
                website: [
                    "Online-Bestellsystem",
                    "Reservierungen",
                    "Essenslieferungs-Partnerschaften"
                ]
            },
            retail: {
                title: "Einzelhandel",
                video: [
                    "Produktdemonstrationen",
                    "Kundenbewertungen",
                    "Unboxing-Videos",
                    "Ladenf\xfchrungen",
                    "Saisonale Werbeaktionen",
                    "Influencer-Kooperationen"
                ],
                photography: [
                    "Hochwertige Produktfotografie",
                    "Lifestyle-Aufnahmen",
                    "Laden Innen-/Au\xdfenaufnahmen",
                    "Model-Aufnahmen"
                ],
                social: [
                    "Produkteinf\xfchrungen",
                    "Verkaufsank\xfcndigungen",
                    "Blick hinter die Kulissen",
                    "Kundenspotlights",
                    "Influencer-Marketing"
                ],
                print: [
                    "Brosch\xfcren",
                    "Flyer",
                    "Schaufenstergestaltung",
                    "Ladenbeschilderung",
                    "Preisschilder",
                    "Visitenkarten"
                ],
                website: [
                    "E-Commerce-Plattform",
                    "Online-Kataloge",
                    "Kundenbewertungen"
                ]
            },
            salons: {
                title: "Salons & Spas",
                video: [
                    "Behandlungsdemonstrationen",
                    "Kundenbewertungen",
                    "Spa-F\xfchrungen",
                    "Vorher-Nachher-Transformationen",
                    "Mitarbeitervorstellungen"
                ],
                photography: [
                    "Hochwertige Aufnahmen der Dienste",
                    "Mitarbeiterfotos",
                    "Spa-Ambiente",
                    "Kundenportr\xe4ts"
                ],
                social: [
                    "Behandlungsangebote",
                    "Werbeaktionen",
                    "Mitarbeiter-Spotlights",
                    "Kundentransformationen"
                ],
                print: [
                    "Servicemen\xfcs",
                    "Geschenkgutscheine",
                    "Visitenkarten",
                    "Werbematerialien"
                ],
                website: [
                    "Online-Buchung",
                    "Servicebeschreibungen",
                    "Mitarbeiterprofile"
                ]
            },
            fitness: {
                title: "Fitnesscenter & Studios",
                video: [
                    "Workout-Tutorials",
                    "Erfolgsgeschichten der Mitglieder",
                    "Einrichtungsf\xfchrungen",
                    "Kursvorschauen",
                    "Trainer-Vorstellungen"
                ],
                photography: [
                    "Einrichtungsfotos",
                    "Kurs-Action-Aufnahmen",
                    "Ger\xe4tevorf\xfchrungen",
                    "Mitgliedertransformationen"
                ],
                social: [
                    "Workout-Tipps",
                    "Ern\xe4hrungsberatung",
                    "Mitglieder-Spotlights",
                    "Kurspl\xe4ne",
                    "Spezielle Events"
                ],
                print: [
                    "Kurspl\xe4ne",
                    "Mitgliedschaftsbrosch\xfcren",
                    "Visitenkarten",
                    "Werbeflyer"
                ],
                website: [
                    "Kursbuchungssystem",
                    "Mitgliedschaftsoptionen",
                    "Trainer-Profile"
                ]
            },
            realestate: {
                title: "Immobilienmakler",
                video: [
                    "Immobilienbesichtigungen",
                    "Gebietsf\xfchrungen",
                    "Maklervorstellungen",
                    "Kundenbewertungen",
                    "Marktaktualisierungen"
                ],
                photography: [
                    "Professionelle Immobilienfotos",
                    "Luftaufnahmen",
                    "Makler-Portraits",
                    "Umgebungsaufnahmen"
                ],
                social: [
                    "Immobilienangebote",
                    "Open-House-Ank\xfcndigungen",
                    "Markteinblicke",
                    "Kundenerfolgsstories"
                ],
                print: [
                    "Immobilienexpos\xe9s",
                    "Visitenkarten",
                    "Direktwerbung",
                    "Immobilienflyer"
                ],
                website: [
                    "Immobilienlistings",
                    "Virtuelle Touren",
                    "Maklerprofile",
                    "Kundenbewertungen"
                ]
            },
            professional: {
                title: "Professionelle Dienste",
                video: [
                    "Kundenreferenzen",
                    "Serviceerkl\xe4rungen",
                    "Unternehmenskultur-Videos",
                    "Experteninterviews",
                    "Prozessvorf\xfchrungen"
                ],
                photography: [
                    "Professionelle Portraits",
                    "B\xfcroumgebung",
                    "Teamfotos",
                    "Eventdokumentation"
                ],
                social: [
                    "Brancheneinblicke",
                    "Unternehmens-Updates",
                    "Team-Spotlights",
                    "Kundenerfolgsstories"
                ],
                print: [
                    "Servicebrosch\xfcren",
                    "Visitenkarten",
                    "Pr\xe4sentationsmappen",
                    "Fallstudien-Dokumente"
                ],
                website: [
                    "Servicebeschreibungen",
                    "Team-Profile",
                    "Kundenportal",
                    "Fallstudien"
                ]
            },
            homeservices: {
                title: "HaushaltsDienste",
                video: [
                    "Service-Demonstrationen",
                    "Kundenreferenzen",
                    "Vorher-Nachher-Transformationen",
                    "Team-Vorstellungen",
                    "Sicherheitsverfahren"
                ],
                photography: [
                    "Vorher/Nachher-Fotos",
                    "Teamfotos",
                    "Ausr\xfcstung/Werkzeuge",
                    "Service-Prozess-Aufnahmen"
                ],
                social: [
                    "Wartungstipps",
                    "Saisonale Dienste",
                    "Kundenbewertungen",
                    "Sonderangebote"
                ],
                print: [
                    "Servicebrosch\xfcren",
                    "Visitenkarten",
                    "Angebotsformulare",
                    "T\xfcrh\xe4nger"
                ],
                website: [
                    "Servicebeschreibungen",
                    "Online-Buchung",
                    "Servicegebiete",
                    "Notfalldienste"
                ]
            },
            ecommerce: {
                title: "E-Commerce Unternehmen",
                video: [
                    "Produktdemonstrationen",
                    "Unboxing-Erlebnisse",
                    "Kundenbewertungen",
                    "Blick hinter die Kulissen",
                    "Produkteinf\xfchrungen"
                ],
                photography: [
                    "Produktfotografie",
                    "Lifestyle-Aufnahmen",
                    "Verpackung/Unboxing",
                    "360-Grad-Ansichten"
                ],
                social: [
                    "Produktmerkmale",
                    "Kundenbewertungen",
                    "Sonderaktionen",
                    "Anleitungen"
                ],
                print: [
                    "Produktkataloge",
                    "Verpackungsdesign",
                    "Beilagekarten",
                    "Werbematerialien"
                ],
                website: [
                    "E-Commerce-Plattform",
                    "Produktseiten",
                    "Warenkorb",
                    "Kundenbewertungen"
                ]
            }
        }
    },
    ro: {
        services: {
            video: "Produc\u021Bie video",
            photography: "Fotografie",
            social: "Con\u021Binut social media",
            print: "Materiale print",
            website: "Solu\u021Bii website"
        },
        industries: {
            restaurants: {
                title: "Restaurante \u0219i cafenele",
                video: [
                    "Videoclipuri cu preparate",
                    "Testimoniale clien\u021Bi",
                    "Videoclipuri de ambian\u021B\u0103",
                    "Interviuri cu buc\u0103tari",
                    "Tururi behind-the-scenes \xeen buc\u0103t\u0103rie",
                    "Spotlight pe preparate din meniu",
                    "Videoclipuri tip re\u021Bet\u0103"
                ],
                photography: [
                    "Fotografie culinar\u0103 de calitate",
                    "Fotografii interior/exterior",
                    "Fotografii echip\u0103",
                    "Fotografie evenimente"
                ],
                social: [
                    "Post\u0103ri cu imagini apetisante",
                    "Oferte zilnice",
                    "Concursuri pentru clien\u021Bi",
                    "Colabor\u0103ri cu influenceri"
                ],
                print: [
                    "Meniuri",
                    "Flyere",
                    "Display-uri de mas\u0103",
                    "Carduri de fidelitate",
                    "C\u0103r\u021Bi de vizit\u0103"
                ],
                website: [
                    "Sistem de comenzi online",
                    "Rezerv\u0103ri",
                    "Parteneriate livrare m\xe2ncare"
                ]
            },
            retail: {
                title: "Magazine retail",
                video: [
                    "Demonstra\u021Bii produse",
                    "Testimoniale clien\u021Bi",
                    "Videoclipuri unboxing",
                    "Tururi \xeen magazin",
                    "Promo\u021Bii sezoniere",
                    "Colabor\u0103ri cu influenceri"
                ],
                photography: [
                    "Fotografie produse de calitate",
                    "Fotografii lifestyle",
                    "Fotografii interior/exterior magazin",
                    "Fotografii cu modele"
                ],
                social: [
                    "Lans\u0103ri de produse",
                    "Anun\u021Buri de reduceri",
                    "Behind-the-scenes",
                    "Spotlight clien\u021Bi",
                    "Marketing cu influenceri"
                ],
                print: [
                    "Bro\u0219uri",
                    "Flyere",
                    "Vitrine",
                    "Semnalistic\u0103 \xeen magazin",
                    "Etichete de pre\u021B",
                    "C\u0103r\u021Bi de vizit\u0103"
                ],
                website: [
                    "Platform\u0103 e-commerce",
                    "Cataloage online",
                    "Recenzii clien\u021Bi"
                ]
            },
            salons: {
                title: "Saloane \u0219i spa-uri",
                video: [
                    "Demonstra\u021Bii tratamente",
                    "Testimoniale clien\u021Bi",
                    "Tururi spa",
                    "Transform\u0103ri \xeenainte/dup\u0103",
                    "Prezent\u0103ri echip\u0103"
                ],
                photography: [
                    "Imagini de calitate cu servicii",
                    "Fotografii echip\u0103",
                    "Ambian\u021B\u0103 spa",
                    "Portrete clien\u021Bi"
                ],
                social: [
                    "Oferte tratamente",
                    "Promo\u021Bii",
                    "Spotlight echip\u0103",
                    "Transform\u0103ri clien\u021Bi"
                ],
                print: [
                    "Meniuri servicii",
                    "Vouchere cadou",
                    "C\u0103r\u021Bi de vizit\u0103",
                    "Materiale promo\u021Bionale"
                ],
                website: [
                    "Program\u0103ri online",
                    "Descrieri servicii",
                    "Profiluri echip\u0103"
                ]
            },
            fitness: {
                title: "Centre fitness \u0219i s\u0103li de sport",
                video: [
                    "Tutoriale antrenament",
                    "Pove\u0219ti de succes ale membrilor",
                    "Tururi facilit\u0103\u021Bi",
                    "Previzualiz\u0103ri cursuri",
                    "Prezent\u0103ri antrenori"
                ],
                photography: [
                    "Fotografii facilit\u0103\u021Bi",
                    "Cadre din timpul cursurilor",
                    "Demonstra\u021Bii echipamente",
                    "Transform\u0103ri membri"
                ],
                social: [
                    "Sfaturi antrenament",
                    "Sfaturi nutri\u021Bie",
                    "Spotlight membri",
                    "Programe cursuri",
                    "Evenimente speciale"
                ],
                print: [
                    "Programe cursuri",
                    "Bro\u0219uri abonamente",
                    "C\u0103r\u021Bi de vizit\u0103",
                    "Flyere promo\u021Bionale"
                ],
                website: [
                    "Sistem rezerv\u0103ri cursuri",
                    "Op\u021Biuni abonament",
                    "Profiluri antrenori"
                ]
            },
            realestate: {
                title: "Agen\u021Bii imobiliare",
                video: [
                    "Tururi propriet\u0103\u021Bi",
                    "Ghiduri de zon\u0103",
                    "Prezent\u0103ri agen\u021Bi",
                    "Testimoniale clien\u021Bi",
                    "Actualiz\u0103ri pia\u021B\u0103"
                ],
                photography: [
                    "Fotografii profesionale propriet\u0103\u021Bi",
                    "Fotografie aerian\u0103",
                    "Portrete agen\u021Bi",
                    "Imagini din comunitate"
                ],
                social: [
                    "Anun\u021Buri propriet\u0103\u021Bi",
                    "Anun\u021Buri open house",
                    "Insight-uri pia\u021B\u0103",
                    "Pove\u0219ti de succes clien\u021Bi"
                ],
                print: [
                    "Bro\u0219uri propriet\u0103\u021Bi",
                    "C\u0103r\u021Bi de vizit\u0103",
                    "Materiale direct mail",
                    "Flyere propriet\u0103\u021Bi"
                ],
                website: [
                    "List\u0103ri propriet\u0103\u021Bi",
                    "Tururi virtuale",
                    "Profiluri agen\u021Bi",
                    "Testimoniale clien\u021Bi"
                ]
            },
            professional: {
                title: "Servicii profesionale",
                video: [
                    "Testimoniale clien\u021Bi",
                    "Explica\u021Bii servicii",
                    "Videoclipuri cultur\u0103 companie",
                    "Interviuri exper\u021Bi",
                    "Demonstra\u021Bii proces"
                ],
                photography: [
                    "Portrete profesionale",
                    "Mediul de birou",
                    "Fotografii echip\u0103",
                    "Acoperire evenimente"
                ],
                social: [
                    "Insight-uri din industrie",
                    "Actualiz\u0103ri companie",
                    "Spotlight echip\u0103",
                    "Pove\u0219ti de succes clien\u021Bi"
                ],
                print: [
                    "Bro\u0219uri servicii",
                    "C\u0103r\u021Bi de vizit\u0103",
                    "Mape prezentare",
                    "Documente studii de caz"
                ],
                website: [
                    "Descrieri servicii",
                    "Profiluri echip\u0103",
                    "Portal clien\u021Bi",
                    "Studii de caz"
                ]
            },
            homeservices: {
                title: "Servicii pentru cas\u0103",
                video: [
                    "Demonstra\u021Bii servicii",
                    "Testimoniale clien\u021Bi",
                    "Transform\u0103ri \xeenainte/dup\u0103",
                    "Prezent\u0103ri echip\u0103",
                    "Proceduri de siguran\u021B\u0103"
                ],
                photography: [
                    "Fotografii \xeenainte/dup\u0103",
                    "Fotografii echip\u0103",
                    "Echipamente/unelte",
                    "Cadre din procesul de lucru"
                ],
                social: [
                    "Sfaturi \xeentre\u021Binere",
                    "Servicii sezoniere",
                    "Recenzii clien\u021Bi",
                    "Oferte speciale"
                ],
                print: [
                    "Bro\u0219uri servicii",
                    "C\u0103r\u021Bi de vizit\u0103",
                    "Formulare estim\u0103ri",
                    "Materiale door hanger"
                ],
                website: [
                    "Descrieri servicii",
                    "Program\u0103ri online",
                    "Zone deservite",
                    "Servicii de urgen\u021B\u0103"
                ]
            },
            ecommerce: {
                title: "Afaceri e-commerce",
                video: [
                    "Demonstra\u021Bii produse",
                    "Experien\u021Be unboxing",
                    "Testimoniale clien\u021Bi",
                    "Behind-the-scenes",
                    "Lans\u0103ri de produse"
                ],
                photography: [
                    "Fotografie produse",
                    "Fotografii lifestyle",
                    "Ambalaj/unboxing",
                    "Vederi 360\xb0"
                ],
                social: [
                    "Caracteristici produse",
                    "Recenzii clien\u021Bi",
                    "Promo\u021Bii speciale",
                    "Ghiduri how-to"
                ],
                print: [
                    "Cataloage produse",
                    "Design ambalaje",
                    "Carduri incluse \xeen pachet",
                    "Materiale promo\u021Bionale"
                ],
                website: [
                    "Platform\u0103 e-commerce",
                    "Pagini produse",
                    "Co\u0219 de cump\u0103r\u0103turi",
                    "Recenzii clien\u021Bi"
                ]
            }
        }
    }
};
function $058c5ce0a1ed7cc4$export$46e853d77ff2410e(language = "en") {
    const translations = $058c5ce0a1ed7cc4$export$fff9d43727b7dcf7[language] || $058c5ce0a1ed7cc4$export$fff9d43727b7dcf7.en;
    return Object.entries(translations.industries).reduce((acc, [key, industry])=>{
        acc[key] = {
            title: industry.title,
            services: Object.entries(translations.services).reduce((services, [serviceKey, serviceTitle])=>{
                services[serviceKey] = {
                    title: serviceTitle,
                    items: industry[serviceKey] || []
                };
                return services;
            }, {})
        };
        return acc;
    }, {});
}


function $6fc9cb45f11f44f9$export$29eefc86d31bb934() {
    const dropdown = document.getElementById("industryDropdown");
    const contentDiv = document.getElementById("industryContent");
    if (!dropdown || !contentDiv) return;
    const renderIndustryContent = (industryKey)=>{
        const currentLanguage = document.documentElement.lang || "ro";
        const industryData = (0, $058c5ce0a1ed7cc4$export$46e853d77ff2410e)(currentLanguage);
        const data = industryData[industryKey];
        if (!data) {
            contentDiv.innerHTML = "";
            return;
        }
        const services = Object.entries(data.services);
        contentDiv.innerHTML = `
      <div class="industry-content">
        <div class="industry-columns">
          <div class="industry-column">
            ${services.slice(0, 2).map(([, service])=>`
              <div class="service-section fade-in">
                <h3 class="service-title">${service.title}</h3>
                <p class="service-items">
                  ${service.items.join(". ")}
                </p>
              </div>
            `).join("")}
          </div>
          <div class="industry-column">
            ${services.slice(2, 5).map(([, service])=>`
              <div class="service-section fade-in">
                <h3 class="service-title">${service.title}</h3>
                <p class="service-items">
                  ${service.items.join(". ")}
                </p>
              </div>
            `).join("")}
          </div>
        </div>
      </div>
    `;
    };
    renderIndustryContent(dropdown.value);
    dropdown.addEventListener("change", (e)=>{
        renderIndustryContent(e.target.value);
    });
    document.addEventListener("languageChanged", ()=>{
        renderIndustryContent(dropdown.value);
    });
}
document.addEventListener("DOMContentLoaded", $6fc9cb45f11f44f9$export$29eefc86d31bb934);


//# sourceMappingURL=index.88978e46.js.map
